/* eslint-disable jsx-a11y/anchor-is-valid */
import { Book } from "epubjs";
import { useEffect, useState } from "react";
import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import { useParams, useSearchParams } from "react-router-dom";
import { database } from "../../services/firebase-config";
import { addDoc, updateDoc, collection, getDocs, doc, getDoc } from "firebase/firestore";
import styles from "./styles.module.css";
import { bookThemes } from "./themes.config.js";
import { FaList } from "react-icons/fa";
import { VscColorMode } from "react-icons/vsc";
import { IoTextOutline } from "react-icons/io5";
import { BsBook, BsBookmark, BsBookmarkCheckFill, BsBookmarkFill } from "react-icons/bs";

import Loading from "../Loading";

export default function BookReader() {

    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();


    const [bookTitle, setBookTitle] = useState('Carregando');
    const [bookPercentage, setBookPercentage] = useState(0);
    const [bookNavigation, setBookNavigation] = useState([]);
    const [changeTheme, setChangeTheme] = useState();
    const [changeFontSize, setChangeFontSize] = useState();

    const [navigationIsOpen, setNavigationIsOpen] = useState(false);
    const [listChapterIsOpen, setListChapterIsOpen] = useState(false);
    const [themeIsOpen, setThemeIsOpen] = useState(false);
    const [fontSizeIsOpen, setFontSizeIsOpen] = useState(false);

    const [isBookLoading, setIsBookLoading] = useState(false);

    const [canBookMark, setCanBookMark] = useState(true);

    function setNavigationIsOpenHandler() {
        if (navigationIsOpen) {
            setNavigationIsOpen(false);
        } else {
            setNavigationIsOpen(true);
        }
    }

    function setListChapterIsOpenHandler() {
        if (listChapterIsOpen) {
            setListChapterIsOpen(false);
        } else {
            setListChapterIsOpen(true);
            setThemeIsOpen(false);
            setFontSizeIsOpen(false);
        }
    }

    function setThemeIsOpenHandler() {
        if (themeIsOpen) {
            setThemeIsOpen(false);
        } else {
            setThemeIsOpen(true);
            setListChapterIsOpen(false);
            setFontSizeIsOpen(false);
        }
    }

    function setFontSizeIsOpenHandler() {
        if (fontSizeIsOpen) {
            setFontSizeIsOpen(false);
        } else {
            setFontSizeIsOpen(true);
            setListChapterIsOpen(false);
            setThemeIsOpen(false);
        }
    }

    async function renderBook() {
        setIsBookLoading(true);

        const bookId = params.bookId;
        const userId = searchParams.get("user");

        const pageInfo = {
            location: null,
            percentage: 0
        };

        let userData = null;

        let userLibrary = [];

        if (userId) {
            const userRef = doc(database, 'users', userId);
            const user = await getDoc(userRef);
            userData = user.data();
            userLibrary = userData.library;

            userData.library.map((book) => {
                if (book.bookId == bookId) {
                    pageInfo.percentage = book.bookPercentage;
                    pageInfo.location = book.bookLocation;
                }
                return book;
            })

        }


        const docRef = doc(database, 'e-books', bookId)
        const ebook = await getDoc(docRef);
        const epubFile = ebook.data().file_download_link

        setBookTitle(ebook.data().name);

        const viewer = document.querySelector('#viewer');
        const book = new Book(epubFile, {})
        const rendition = book.renderTo("viewer", {
            width: "100%",
            spread: "always",
            allowScriptedContent: true
        });
        await book.opened;

        if (userData) {
            if (pageInfo.location) {
                var displayed = await rendition.display(pageInfo.location);
                setBookPercentage(pageInfo.percentage);
            } else {
                var displayed = await rendition.display();
            }
        } else {
            var displayed = await rendition.display();
        }

        let itens = [];

        book.navigation.toc.forEach((item) => {
            itens.push(<a key={item.id} className={styles.bookNav__item} onClick={() => {
                rendition.display(item.href).then(() => {
                    setBookPercentage(Math.floor(rendition.currentLocation().start.percentage * 100));
                    setNavigationIsOpen(false);
                });
            }}>{item.label}</a>)
        });
        setBookNavigation(itens);

        // handle font size
        let fonts = [];

        fonts.push(<a key={'small'} className={styles.bookNav__item_font} onClick={() => {
            rendition.themes.fontSize("120%");
            setNavigationIsOpen(false);
            setFontSizeIsOpen(false);
        }}
        >Pequeno</a>)

        fonts.push(<a key={'medium'} className={styles.bookNav__item_font} onClick={() => {
            rendition.themes.fontSize("140%");
            setNavigationIsOpen(false);
            setFontSizeIsOpen(false);
        }}
        >Médio</a>)

        fonts.push(<a key={'large'} className={styles.bookNav__item_font} onClick={() => {
            rendition.themes.fontSize(`${180}%`);
            setNavigationIsOpen(false);
            setFontSizeIsOpen(false);
        }}
        >Grande</a>)

        setChangeFontSize(fonts);

        // handle themes style
        let themes = [];

        themes.push(<a key={'white'} className={styles.bookNav__item_theme} onClick={() => {
            rendition.themes.default(bookThemes.white);
            setNavigationIsOpen(false);
            setThemeIsOpen(false);
        }}
        >Claro</a>)

        themes.push(<a key={'dark'} className={styles.bookNav__item_theme} onClick={() => {
            rendition.themes.default(bookThemes.dark);
            setNavigationIsOpen(false);
            setThemeIsOpen(false);
        }}
        >Escuro</a>)

        themes.push(<a key={'sepia'} className={styles.bookNav__item_theme} onClick={() => {
            rendition.themes.default(bookThemes.sepia);
            setNavigationIsOpen(false);
            setThemeIsOpen(false);
        }}
        >Sépia</a>)

        setChangeTheme(themes);

        await book.locations.generate();

        if (viewer.childNodes.length > 1) {
            while (viewer.childNodes.length > 1) {
                viewer.removeChild(viewer.firstChild);
            }
        }

        if (viewer.childNodes.length === 1) {
            const nextButton = document.querySelector('#nextPageButton');
            const prevButton = document.querySelector('#prevPageButton')

            nextButton.addEventListener('click', () => {
                rendition.next();
                setBookPercentage(Math.floor(rendition.currentLocation().end.percentage * 100));
            });

            prevButton.addEventListener('click', () => {
                rendition.prev();
                setBookPercentage(Math.floor(rendition.currentLocation().start.percentage * 100));
            });
        }

        if (viewer.childNodes.length === 1) {
            const nextButtonHidden = document.querySelector('#nextPageButtonHidden');
            const prevButtonHidden = document.querySelector('#prevPageButtonHidden')

            nextButtonHidden.addEventListener('click', () => {
                rendition.next();
                setBookPercentage(Math.floor(rendition.currentLocation().end.percentage * 100));
            });

            prevButtonHidden.addEventListener('click', () => {
                rendition.prev();
                setBookPercentage(Math.floor(rendition.currentLocation().start.percentage * 100));
            });
        }

        setIsBookLoading(false);

        rendition.themes.default(bookThemes.white);

        var currentLocation = rendition.currentLocation();
        var cfiString = currentLocation.start.cfi;
        rendition.display(cfiString);
        // Essas strings se parecem com isso: epubcfi(/6/4[chap01ref]!/4[body01]/10[para05]/2/1:3) .


        function updateBookData() {

            if (!userData) {
                alert("usuario não encontrado");
                return;
            }

            const userRef = doc(database, 'users', userId);
            const percentage = Math.floor(rendition.currentLocation().end.percentage * 100);
            const location = rendition.currentLocation().start.cfi;
            userLibrary.map((book) => {
                if (book.bookId == bookId) {
                    book.bookId = bookId;
                    book.bookPercentage = percentage;
                    book.bookLocation = location;
                }
                return book;
            })

            updateDoc(userRef, {
                library: userLibrary
            });

            alert("Página marcada com sucesso\nAo retomar a leitura, irá retornar desta página.")
            return;
        };

        const bookMarkButton = document.querySelector("#bookMarkButton");
        bookMarkButton.addEventListener("click", () => {
            if (canBookMark) {
                updateBookData();
                setCanBookMark(false);
                setTimeout(() => {
                    setCanBookMark(true);
                }, 5000)

            }
        });

    }


    useEffect(() => {
        renderBook();
    }, []);

    return (
        <div className={`${styles.bookReader} ${isBookLoading && styles.loading}`}>
            {isBookLoading && <Loading />}
            <div className={styles.bookReader__header}>
                <div className={styles.bookReader__header__right}>
                    <FaList onClick={setNavigationIsOpenHandler} className={styles.bookReader__openNavButton} />
                    <h1 className={styles.bookReader__header__title} >{bookTitle}</h1>
                </div>
                <div className={styles.bookReader__controls} >
                    {canBookMark ?
                        <button disabled={!canBookMark} id="bookMarkButton"><BsBookmark /></button> :
                        <button disabled><BsBookmarkCheckFill /></button>
                    }

                    <button id='prevPageButton'>< MdArrowBackIos /></button>
                    <p>{bookPercentage}%</p>
                    <button id="nextPageButton"><MdArrowForwardIos /></button>
                </div>
            </div>

            {navigationIsOpen &&
                <div className={styles.bookNav}>
                    <div className={styles.handleStyles}>
                        <BsBook onClick={setListChapterIsOpenHandler} className={styles.bookReader__openNavButton} />
                        <IoTextOutline onClick={setFontSizeIsOpenHandler} className={styles.bookReader__openNavButton} />
                        <VscColorMode onClick={setThemeIsOpenHandler} className={styles.bookReader__openNavButton} />
                    </div>
                    {listChapterIsOpen && bookNavigation}
                    {themeIsOpen && changeTheme}
                    {fontSizeIsOpen && changeFontSize}
                </div>
            }
            <div className={styles.bookReader__bookContainer}>
                <div className={styles.bookReader__divHiddenProgression} >
                    <button id='prevPageButtonHidden' className={styles.hidden}><MdArrowBackIos /></button>
                    <button id='nextPageButtonHidden' className={styles.hidden}><MdArrowForwardIos /></button>
                </div>
                <div id="viewer"></div>
            </div>
        </div>
    );
}